import React from 'react';
import PropTypes from 'prop-types';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';
import PageLayout from '../layouts/PageLayout/PageLayout';
import Home from './Home/Home';
import SuuntoHome from './Home/SuuntoHome';
import GetStarted from './GetStarted/GetStarted';
// import Login from './Login/Login';
// import Logout from './Logout/Logout';
import PasswordReset from './PasswordReset/PasswordReset';
import AccountDeletion from './AccountDeletion/AccountDeletion';
// import Feed from './Feed/Feed';
import Workout from './Workout/AsyncWrapperForWorkout';
import PageNotFound from './PageNotFound/PageNotFound';
// import Example from './Example/AsyncWrapperForExample';
import OnboardingTianjin22987112 from './Onboarding/Tianjin/2.29.8.7112';
import Partners from './Partners/Partners';

function showContentOnly(location) {
  return Boolean(location && location.search && location.search.match(/contentOnly=true/g));
}

export function RouteWithLayout({
  noAdBanner, component: Component, location, ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <PageLayout noAdBanner={noAdBanner} contentOnly={showContentOnly(location)}>
          <Component {...props} />
        </PageLayout>
      )}
    />
  );
}
RouteWithLayout.defaultProps = {
  noAdBanner: false,
};
RouteWithLayout.propTypes = {
  noAdBanner: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  location: PropTypes.object,
};

export default function Routes() {
  return (
    <Router>
      <Switch>
        <Route path="/home" render={() => <Redirect from="/home" to="/" />} />
        <Route path="/rt" render={({ location }) => <Redirect to={{ pathname: '/password-reset', search: location.search }} />} />
        <RouteWithLayout exact path="/" noAdBanner component={__BRAND__.name === 'suunto' ? SuuntoHome : Home} />
        <RouteWithLayout exact path="/getstarted" noAdBanner component={GetStarted} />
        {/* __DEV__ && <RouteWithLayout exact path="/login" component={Login} /> */}
        {/* __DEV__ && <RouteWithLayout exact path="/logout" component={Logout} /> */}
        {/* __DEV__ && <RouteWithLayout exact path="/feed" component={Feed} /> */}
        {/* __DEV__ && <RouteWithLayout exact path="/example" component={Example} /> */}
        <RouteWithLayout noAdBanner path="/workout/:userName/:id" component={Workout} />
        <RouteWithLayout noAdBanner path="/move/:userName/:id" component={Workout} />
        <RouteWithLayout noAdBanner path="/password-reset" component={PasswordReset} />
        <RouteWithLayout noAdBanner path="/delete-account" component={AccountDeletion} />
        <Route path="/tianjin/onboarding/2.29.8.7112" component={OnboardingTianjin22987112} />
        <Route path="/tianjin/onboarding" component={OnboardingTianjin22987112} />
        <Route path="/suuntorace/onboarding" component={OnboardingTianjin22987112} />
        <RouteWithLayout noAdBanner path="/partners/:id" component={Partners} />
        <RouteWithLayout noAdBanner path="/partners" component={Partners} />
        <RouteWithLayout noAdBanner component={PageNotFound} />
      </Switch>
    </Router>
  );
}
